import { useRef, useEffect, useCallback } from 'react';
import { AbortController, AbortSignal } from 'node-abort-controller';
// Server side rendering use node-abort-controller

// eslint-disable-next-line no-prototype-builtins
export interface ISignal extends AbortSignal {
  reason?: unknown;
  throwIfAborted(): void;
}
interface IAbortRef {
  current: AbortController | { abort: () => void; signal: AbortSignal };
}

const initAbortController = () => new AbortController();

export const useAbortController = (shouldAutoRestart = false) => {
  const abortController: IAbortRef = useRef(initAbortController());

  useEffect(() => {
    if (shouldAutoRestart && abortController.current.signal.aborted) {
      abortController.current = initAbortController();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [abortController.current.signal.aborted]);

  useEffect(() => () => abortController.current.abort(), []);

  return useCallback(() => abortController.current, [abortController]);
};
